import { z } from 'zod';

export const createSprintInputSchema = z.object({
  name: z.string().trim().min(1).max(80),
  goal: z.string().trim().max(500).optional(),
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional(),
  capacityPoints: z.number().int().positive().max(500).optional(),
});
export type CreateSprintInput = z.infer<typeof createSprintInputSchema>;

export const updateSprintInputSchema = z.object({
  name: z.string().trim().min(1).max(80).optional(),
  goal: z.string().trim().max(500).nullable().optional(),
  startDate: z.string().datetime().nullable().optional(),
  endDate: z.string().datetime().nullable().optional(),
  capacityPoints: z.number().int().positive().max(500).optional(),
});
export type UpdateSprintInput = z.infer<typeof updateSprintInputSchema>;

export const startSprintInputSchema = z.object({
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional(),
});
export type StartSprintInput = z.infer<typeof startSprintInputSchema>;

export const completeSprintInputSchema = z.object({
  carryoverTarget: z.enum(['BACKLOG', 'SPRINT']).default('BACKLOG'),
  targetSprintId: z.string().min(1).optional(),
});
export type CompleteSprintInput = z.infer<typeof completeSprintInputSchema>;
